export default {
    bold: 'Poppins-Bold',
    semiBold: 'Poppins-SemiBold',
    regular: 'Poppins-Regular',
}